import BeehiivSubscribeForm from "@/components/newsletter/BeehiivSubscribeForm";

export default function NewsletterHero() {
  return (
    <section
      id="newsletter-hero"
      className="w-full bg-black py-10 font-fira text-white"
    >
      {/* Frame: full width mobile, 98% desktop; 1px gradient border */}
      <div className="mx-auto w-[90%] md:w-[98%]">
        <div className="rounded-b-2xl rounded-t-none p-px md:rounded-b-3xl">
          <div className="relative min-h-[min(70dvh,44rem)] overflow-hidden rounded-3xl border border-[#FFFFFF29] md:min-h-[min(65dvh,40rem)] md:rounded-b-3xl">
            {/* Background image */}
            <picture className="pointer-events-none absolute inset-0">
              <source
                media="(min-width: 768px)"
                srcSet="/resources/newsherod.webp"
              />
              <img
                src="/resources/newsherom.webp"
                alt=""
                className="h-full w-full object-cover object-center"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </picture>

            {/* Dark overlay on the left so text is readable */}
            <div className="pointer-events-none absolute inset-0" />

            {/* Content */}
            <div className="relative z-10 flex min-h-[min(70dvh,44rem)] flex-col justify-end px-8 py-12 md:min-h-[min(65dvh,40rem)] md:justify-center md:px-16 md:py-16 lg:px-24">
              <div className="flex flex-col items-start md:max-w-xl">
                <h1 className="font-fira-condensed text-[36px] font-medium md:font-semibold leading-tight tracking-tight text-white md:text-[56px]">
                  Your Weekly
                  <br />
                  AI Update
                </h1>

                <p className="font-fira mt-3 text-[14px] font-normal leading-relaxed text-[#FFFFFF80] md:mt-4 md:text-[18px]">
                  A weekly newsletter on what matters in AI.
                </p>

                <div id="join" className="mt-6 w-full max-w-lg md:mt-8">
                  <BeehiivSubscribeForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
